import React, { useContext } from 'react';

import GlobalContext from 'site/context';
import CardFields from './card-fields';

export default props => {
    const { isLoggedIn, user, showFlash } = useContext(GlobalContext);
    return (
        <CardFields
            firstName={isLoggedIn ? user.firstName : ''}
            lastName={isLoggedIn ? user.lastName : ''}
            email={isLoggedIn ? user.email : ''}
            showFlash={showFlash}
            {...props}
        />
    );
};
